export enum LeadStatus {
    'Not Looking' = 0,
    'New Lead' = 20,
    'Qualified' = 40,
    'Offers Pending' = 60,
    'Closing' = 80,
    'Sold' = 100
}
